module.exports = __webpack_public_path__ + "media/images/icon/payment/master-card-0b2eb5e7104b98215a5b4c7e4f34ed94.svg";